import Swiper from 'swiper';
import { Navigation, EffectFade, Pagination } from 'swiper/modules';

Swiper.use([Navigation, EffectFade, Pagination]);

export default function () {
	// Initiate the swiper

	const imageTextCarousels = document.querySelectorAll(
		'.js-image-text-carousel'
	);

	imageTextCarousels.forEach((carousel) => {
		if (carousel.querySelectorAll('.swiper-slide').length > 1) {
			const config = {
				autoHeight: true,
				effect: 'fade',
				fadeEffect: {
					crossFade: true,
				},
				navigation: {
					nextEl: '.image-text-carousel__next',
					prevEl: '.image-text-carousel__prev',
				},
				pagination: {
					el: '.swiper-pagination',
					type: 'fraction',
				},
				simulateTouch: false,
				breakpoints: {
					// when window width is >= 768px
					768: {
						autoHeight: false,
					},
				},
			};

			new Swiper(carousel, config);
		}
	});
}
